import React from "react";
import { Col, Navbar, NavLink, Row, Spinner } from "react-bootstrap";
import styles from "./Location.module.scss";
import * as CONSTANT from "../../constants";
import { FormField } from "../../components/FormFields/FormField";
import { Formik, FormikHelpers, FormikValues } from "formik";
import { UserFormData } from "../../components/Footer/PopUpModel";
import { emailSubsFormValidationSchema } from "../../validationSchemas/contactUsSchema";
import { getUser } from "../../helpers/helperMethods";
import { customerBusinessService } from "../../services";
import { Toast_Func } from "../../helpers/toast.helper";

const NewsletterForm = () => {
  const socialIconsArray = [
    {
      link: `${CONSTANT.CAFEZUPAS_FACEBOOK_URL}cafezupas/`,
      icon: `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/icons/facebook-icon.svg`,
      socail_alt_text: `facebook`,
    },
    {
      link: `${CONSTANT.CAFEZUPAS_INSTAGRAM_URL}cafezupas/`,
      icon: `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/icons/Instagram-icon.svg`,
      socail_alt_text: `instargram`,
    },
    {
      link: `${CONSTANT.CAFEZUPAS_PINTEREST_URL}cafezupas/_created/`,
      icon: `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/icons/pinterest-icon.svg`,
      socail_alt_text: `pinterest`,
    },
    {
      link: `${CONSTANT.CAFEZUPAS_TWITTER_URL}cafezupas`,
      icon: `${CONSTANT.REACT_APP_CLOUD_FRONT}/images/icons/twitter-icon.svg`,
      socail_alt_text: `twitter`,
    },
  ];
  const defaultUserFormState: UserFormData = {
    email: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setSubmitting(true);
      const user = getUser();
      const payload = 
        {
          customer_id: user.id,
          visitor_id: user.visitor_id,
          ...values
        };
      const response = await customerBusinessService.subscribeEmail(payload);
      Toast_Func({
        status: true,
        message: 'Thank You! You are now on our mailing list.',
      });
      resetForm();
    } catch (error) {
      Toast_Func({
        status: false,
        message: error.response.data.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <form className={styles.newslatterForm}>
        <Row>
          <Col md={7} xs={12} className="m-auto">
            <Formik
              className="form-group w-100 mb-0"
              initialValues={defaultUserFormState}
              onSubmit={handleSubmit}
              validationSchema={emailSubsFormValidationSchema}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                isSubmitting,
              }) => (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className={` d-flex gap-3 ${styles.formCol} w-100`}
                  >
                    <FormField
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      onChange={handleChange}
                      value={values.email}
                      errors={errors}
                      touched={touched}
                      parentDivClass="w-100 mb-0"
                    />
                    <div>
                      <button
                        className={`${styles.signup_button} dark-grey text-uppercase lh-normal px-md-5  f-w6 d-flex align-items-center justify-content-center gap-1`}
                        type="submit"
                        value="SIGN UP"
                        disabled={isSubmitting}
                      >
                        Subscribe
                       {isSubmitting &&  <Spinner animation={"border"} size="sm" />} 
                      </button>
                    </div>
                  </form>
                </>
              )}
            </Formik>
          </Col>
        </Row>
      </form>
      <Row>
        <Col md={7} xs={12} className="m-auto">
          <Navbar
            expand="md"
            className={`${styles.footer_Nav_links_wrap} footer_Nav_links_wrap w-auto align-items-center`}
          >
            {socialIconsArray.map((item, j) => (
              <NavLink href={item.link} key={j}>
                <img
                  src={item.icon}
                  className={styles.social_icons_items}
                  alt={item.socail_alt_text}
                />
              </NavLink>
            ))}
          </Navbar>
        </Col>
      </Row>
    </>
  );
};

export default NewsletterForm;
